import { motion } from "framer-motion";

function AddOnLine({ line }) {
  return <li>{line}</li>;
}

function AddOnCard({ title, lines, delay }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay }}
      className="p-6 rounded-2xl bg-gray-900/50 border border-gray-800"
    >
      <h3 className="text-lg font-semibold text-white mb-4">{title}</h3>
      <ul className="space-y-2 text-sm text-gray-400">
        {lines.map((line, i) => (
          <AddOnLine key={i} line={line} />
        ))}
      </ul>
    </motion.div>
  );
}

function renderLine(label, value) {
  return (
    <>
      {label}: <span className="text-white">{value}</span>
    </>
  );
}

export default function AddOnsSection({ groups }) {
  // Pre-compute the JSX nodes for each group's items to avoid nested
  // member-expression chains in inline `.map()` calls (which can trigger
  // a known stack-overflow in the local visual-edits babel plugin).
  const cards = groups.map((group, index) => {
    const lines = group.items.map((it) => renderLine(it.label, it.value));
    return { title: group.title, lines, delay: index * 0.1 };
  });

  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
      {cards.map((c) => (
        <AddOnCard key={c.title} title={c.title} lines={c.lines} delay={c.delay} />
      ))}
    </div>
  );
}
